export default function BCPBaseController(
  userService
) {
  const vm = this;

  console.log('app.components.advisory.bcp.bcpBaseController created');

  /** ********************************
   * Public API
   */

  vm.initPermissions = _initPermissions;

  /** ********************************
   * Private Functions
   */

  function _initPermissions() {
    return userService.getUserPermissionSet('bcp').then((permissions) => {
      vm.permissions = permissions;
    });
  }
}
